import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgMomentumStrongNegative = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 40,
	height: 40,
	viewBox: "0 0 40 40",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M23.7892 28.4423C23.7892 27.6756 24.379 27.0269 25.2047 27.0269H32.1639L21.843 16.765L15.2966 23.3114C14.7658 23.9011 13.8812 23.9011 13.3504 23.3114L3.44232 13.4033C2.85256 12.8725 2.85256 11.9879 3.44232 11.3981C3.97311 10.8673 4.85776 10.8673 5.44753 11.3981L14.353 20.3036L20.8994 13.7572C21.4302 13.2264 22.3148 13.2264 22.9046 13.7572L34.1691 25.0807V18.0624C34.1691 17.2958 34.7589 16.647 35.5846 16.647C36.3513 16.647 37 17.2958 37 18.0624V28.4423C37 29.268 36.3513 29.8578 35.5846 29.8578H25.2047C24.379 29.8578 23.7892 29.268 23.7892 28.4423Z" })
});
export default SvgMomentumStrongNegative;
